export const axiosConfig = {
  headers: {
    "Content-type": "application/json",
  },
};
